import { Box } from '@chakra-ui/react'
import { DiscoverSsmCard } from '@ui'
import SwiperCore, { Navigation, Pagination } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
// import DISCOVER_SSM_SLIDER_CONTENT from '@lib/const/discover-ssm-slider.const'
import { IDiscoverSsmCard } from '@interfaces'

// install Swiper modules
SwiperCore.use([Navigation, Pagination])

interface IDiscoverSsmSlider {
  sliderCollection: IDiscoverSsmCard[]
}

const DiscoverSsmSlider = ({ sliderCollection }: IDiscoverSsmSlider) => {
  return (
    <Box
      className="DiscoverSSMSwiper"
      mt="padding.primary"
      sx={{
        '&.DiscoverSSMSwiper .swiper-container': {
          pl: { base: 'padding.primary', lg: '0' },
          pb: { base: '40px', lg: '0' },
        },
        '&.DiscoverSSMSwiper .swiper-slide': {
          width: 'auto',
        },
        '&.DiscoverSSMSwiper .swiper-pagination-bullet.swiper-pagination-bullet-active':
          {
            backgroundColor: 'red.primary',
            transition: 'all 0.3s cubic-bezier(0.25, 1, 0.5, 1)',
          },
        '&.DiscoverSSMSwiper .swiper-pagination-bullet': {
          opacity: 1,
          width: '102px',
          height: '2px',
          borderRadius: 'none',
          backgroundColor: 'blackAlpha.primary10',
          transition: 'all 0.3s cubic-bezier(0.25, 1, 0.5, 1)',
        },
        '&.DiscoverSSMSwiper .swiper-pagination': {
          display: { base: 'block', lg: 'none' },
        },
        '@media screen and (max-width: 320px)': {
          '&.DiscoverSSMSwiper .swiper-pagination-bullet': {
            width: '50px',
          },
        },
      }}
    >
      <Swiper
        slidesPerView="auto"
        breakpoints={{
          0: {
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
            },
          },
          1170: {
            centeredSlides: true,
            initialSlide: 1,
            noSwiping: true,
            noSwipingClass: 'swiper-container',
          },
        }}
      >
        {sliderCollection.map((slide) => (
          <SwiperSlide key={slide.id}>
            <DiscoverSsmCard
              title={slide.title}
              description={slide.description}
              imgUrl={slide.imgUrl}
              buttonLabel={slide.buttonLabel}
              buttonUrl={slide.buttonUrl}
            />
          </SwiperSlide>
        ))}
        <Box className="swiper-pagination" />
      </Swiper>
    </Box>
  )
}

export default DiscoverSsmSlider